module.exports = __webpack_public_path__ + "img/wooddoor.fd504eb2.png";